var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2335_35412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4655 17.4601C41.0716 18.4006 40.572 19.2937 39.9703 20.1139C37.3373 17.482 33.7635 16.002 30.0401 16.002C22.3381 16.002 16 22.3448 16 30.0547C16 33.9005 17.5754 37.5823 20.3616 40.2361L20.8794 40.6954C23.4103 42.8279 26.6158 44.0017 29.9234 44.0017C37.2462 44.0017 43.4019 38.2639 43.9234 30.9514C44.3063 27.3717 43.2561 22.8442 41.4655 17.4601ZM22.3563 40.3163C22.1302 40.597 21.7838 40.761 21.4228 40.761C20.7627 40.761 20.223 40.2178 20.223 39.558C20.223 38.8982 20.7663 38.3551 21.4228 38.3551C21.6963 38.3551 21.9661 38.4499 22.1776 38.6248C22.6918 39.0404 22.7721 39.8023 22.3563 40.3163ZM41.4071 36.1096C37.9427 40.7282 30.5434 39.1716 25.7989 39.394C25.7989 39.394 24.9565 39.445 24.1104 39.5836C24.1104 39.5836 24.4277 39.4487 24.8398 39.2919C28.1693 38.1327 29.7447 37.9067 31.7687 36.8678C35.5796 34.9285 39.3467 30.6853 40.1308 26.2708C38.6793 30.5176 34.2813 34.1666 30.2735 35.6503C27.5275 36.6637 22.5679 37.6479 22.5679 37.6479L22.3673 37.5422C18.9904 35.8981 18.8883 28.582 25.0258 26.2198C27.7135 25.1845 30.2844 25.7532 33.1873 25.0606C36.2871 24.3242 39.8718 21.9985 41.3306 18.9656C42.9643 23.8175 44.9299 31.4144 41.4071 36.1096Z",
    fill: "#77BC1F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2335_35412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow22);
export default __webpack_public_path__ + "static/media/row-2-2.483481399a758680df9779e8e23a2e26.svg";
export { ForwardRef as ReactComponent };